import HomeIcon from "@mui/icons-material/Home"
import RestaurantIcon from "@mui/icons-material/Restaurant"
import RestaurantMenuIcon from "@mui/icons-material/RestaurantMenu"
import { BottomNavigation, BottomNavigationAction } from "@mui/material"
import { useLocation, useNavigate } from "react-router-dom"
import { useSelector } from "react-redux"
import { RootState } from "../app/store"
import { useTranslation } from "react-i18next"
import { BOTTOM_NAV_HEIGHT } from "./layoutConstants"

type MobileBottomNavProps = {
  isVisible: boolean
}

export function MobileBottomNav({ isVisible }: MobileBottomNavProps) {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { pathname, hash } = useLocation()
  const user = useSelector((state: RootState) => state.user)
  const pathParts = pathname.split("/")
  const userId = pathParts[2]

  if (!isVisible || user.user == null) {
    return null
  }

  const homePath = `/user/${userId}/home`

  const handleLogClick = () => {
    if (pathname.includes(`/user/${userId}/home`)) {
      document.getElementById("log")?.scrollIntoView({ behavior: "smooth", block: "start" })
      navigate(`/user/${userId}/home#log`, { replace: true })
      return
    }
    navigate(`/user/${userId}/home#log`)
  }

  const activeNavItem =
    pathname === homePath && hash === '#log'
      ? 'log'
      : pathname === homePath || pathname.startsWith(`${homePath}/`)
        ? 'dashboard'
        : pathname.startsWith(`/user/${userId}/meals`)
          ? 'meals'
          : ''

  const bottomNavValue =
    activeNavItem === 'dashboard'
      ? 'dashboard'
      : activeNavItem === 'log'
        ? 'log'
        : activeNavItem === 'meals'
          ? 'meals'
          : ''

  return (
    <BottomNavigation
      showLabels
      value={bottomNavValue}
      onChange={(_event, newValue) => {
        if (newValue === "dashboard") {
          navigate(`/user/${userId}/home`)
        } else if (newValue === "log") {
          handleLogClick()
        } else if (newValue === "meals") {
          navigate(`/user/${userId}/meals`)
        }
      }}
      sx={{ height: BOTTOM_NAV_HEIGHT, backgroundColor: "transparent" }}
    >
      <BottomNavigationAction label={t("navigation.dashboard")} value="dashboard" icon={<HomeIcon />} />
      <BottomNavigationAction label={t("navigation.log")} value="log" icon={<RestaurantIcon />} />
      <BottomNavigationAction label={t("navigation.history")} value="meals" icon={<RestaurantMenuIcon />} />
    </BottomNavigation>
  )
}
